import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { EnvironmentService } from '@core/services/environment.service';
import { NavigationService } from '@core/services/navigation.service';

@Directive({
    selector: '[appNavigationScrollInverseColors]',
    standalone: true,
})
export class NavigationScrollInverseColorsDirective implements AfterViewInit {
    @Input() observerOptions: IntersectionObserverInit = {
        root: null,
        // remove 100px from top of the viewport container
        rootMargin: '-100px 0px 0px 0px',
        threshold: 0.0,
    };

    @Input() set defaultColor(value: 'white' | 'transparent') {
        if (value === 'transparent') {
            this.navgationService.setNavbarInverseColors(false);
        } else {
            this.navgationService.setNavbarInverseColors(true);
        }
    }

    private observer: IntersectionObserver;

    constructor(
        private elementRef: ElementRef,
        private environmentService: EnvironmentService,
        private navgationService: NavigationService
    ) {}

    ngAfterViewInit(): void {
        if (this.environmentService.isBrowser()) {
            const options = this.observerOptions;
            this.observer = new IntersectionObserver((entries, observer) => {
                const isVisible = entries
                    .map(value => value.isIntersecting)
                    .reduce(
                        (previousValue, currentValue) =>
                            previousValue && currentValue,
                        true
                    );
                this.navgationService.setNavbarInverseColors(!isVisible);
            }, options);
            this.observer.observe(this.elementRef.nativeElement);
        }
    }

    ngOnDestroy(): void {
        if (this.environmentService.isBrowser()) {
            this.navgationService.setNavbarInverseColors(true);
            this.observer.unobserve(this.elementRef.nativeElement);
        }
    }
}
